import React from 'react'
import cn from 'classnames'

import { ITextProps } from './interface'
import { EColorsName } from 'app/constants/colors'

import './styles.scss'

const bc = `heading`

const Text: React.FC<ITextProps> = ({
  htmlTag,
  customWrapperClass,
  customTitleClass,
  inline,
  isSubtitle,
  children,
  color,
  fontSize,
  styles,
  onClick,
}) => {
  const CustomTextTag = htmlTag || ('p' as any)

  return (
    <div
      className={cn(bc, {
        [customWrapperClass as string]: customWrapperClass,
        inline: inline,
        orange: color === EColorsName.ORANGE,
        grey: color === EColorsName.GREY,
        dark_grey: color === EColorsName.DARK_GREY,
      })}
      style={styles}
      onClick={onClick}
    >
      <CustomTextTag
        className={cn({
          [customTitleClass as string]: customTitleClass,
          subtitle: isSubtitle,
        })}
        style={{ fontSize: `${fontSize}px` }}
      >
        {children}
      </CustomTextTag>
    </div>
  )
}

export default Text
